import React, { useState } from 'react';
import { useAppContext } from '../../../hooks/AppContext';
import { RadioTile, TileGroup } from 'carbon-components-react';
import { segmentTracking } from '../../../lib/tracker';
import messages from 'src/apps/envizi-price-estimator/locales/messages';
import { QuestionData } from 'src/apps/envizi-price-estimator/types';
import { createUseTranslation } from '../../../../../common/hooks/widgets/useTranslation';
import { useEnviziSelector } from '../../../lib/redux/hooks';

export type step4Props = {
  isOpen: boolean;
  question?: QuestionData;
  setCompliance: React.Dispatch<React.SetStateAction<string>>;
  showPrice: boolean;
};

const Step4 = ({ isOpen, setCompliance, showPrice }: step4Props) => {
  const { appAction } = useAppContext();
  const [, setInsightOption] = useState('');
  const AEMMessages = useEnviziSelector((state) => state.translations.messages);
  const useTranslation = createUseTranslation(messages, AEMMessages);

  const handleCompliance = (
    e: React.MouseEvent<HTMLInputElement>,
    id: string,
  ) => {
    const value = (e.target as HTMLInputElement).value;
    setCompliance(value);
    segmentTracking('CTA Clicked', {
      pageTitle: 'Envizi Price Estimator',
      object: 'Envizi page',
      resultValue: 'CTA clicked',
      CTA: 'Compliance radio input',
      location: 'Assessment',
      action: '',
      field: '',
    });
    appAction({
      type: 'answerSingle',
      answerId: id,
      answerValue: `${value} Cookie-${value}`,
    });
  };

  const handleInsight = (e: React.MouseEvent<HTMLInputElement>, id: string) => {
    const value = (e.target as HTMLInputElement).value;
    setInsightOption(value);
    segmentTracking('CTA Clicked', {
      pageTitle: 'Envizi Price Estimator',
      object: 'Envizi page',
      resultValue: 'CTA clicked',
      CTA: 'Insight radio input',
      location: 'Assessment',
      action: '',
      field: '',
    });
    appAction({
      type: 'answerSingle',
      answerId: id,
      answerValue: `${value} Cookie-${value}`,
    });
  };

  return isOpen ? (
    <div>
      <h5 className="que-heading padding_8">
        {useTranslation('que4_sub1_label')}
      </h5>
      <TileGroup name="radio-group" className="tilegroup">
        <RadioTile
          className="tile"
          id={`radio-compliance-yes`}
          value={'Yes'}
          onClick={(e) => handleCompliance(e, 'Q5A1')}
          disabled={showPrice}
        >
          {useTranslation('yes')}
        </RadioTile>
        <RadioTile
          className="tile"
          id={`radio-compliance-no`}
          value={'No'}
          disabled={showPrice}
          onClick={(e) => handleCompliance(e, 'Q5A2')}
        >
          {useTranslation('no')}
        </RadioTile>
      </TileGroup>
      <br />
      <h5 className="que-heading padding_8">
        {useTranslation('que4_sub2_label')}
      </h5>
      <TileGroup name="radio-group" className="tilegroup">
        <RadioTile
          className="tile"
          id={`radio-insight-yes`}
          value={'Yes'}
          onClick={(e) => handleInsight(e, 'Q6A1')}
          disabled={showPrice}
        >
          {useTranslation('yes')}
        </RadioTile>
        <RadioTile
          className="tile"
          id={`radio-insight-no`}
          value={'No'}
          disabled={showPrice}
          onClick={(e) => handleInsight(e, 'Q6A2')}
        >
          {useTranslation('no')}
        </RadioTile>
      </TileGroup>
    </div>
  ) : null;
};

export default Step4;
